var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"refresh",attrs:{"id":"refresh","href":"#refresh"},on:{"click":function($event){$event.preventDefault();return _vm.refresh.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('REFRESH')))])}
var staticRenderFns = []

export { render, staticRenderFns }